module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"outbound-date":"Departure","inbound-date":"Return"},"zh-TW":{"outbound-date":"去程日期","inbound-date":"回程日期"}}')
  delete Component.options._Ctor
}
